module.exports = __webpack_public_path__ + "static/media/genitourinary-system-diseases-icon.fed608e4.svg";